import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiMenu, FiX } = FiIcons;

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const LOGO_URL = "https://media-manager-c.questera.ai/greta-media/2927c86c700ec49dd101b06d8f665ec936c446223b03db97ee166b3b81a38e088d244e0b8a3abf82b7f680071b9e9e7b/images/aW1hZ2UvcG5n/938af48630f3844187713f8a83e6a456.png";
  const AFFILIATE_LINK = "https://learn.augustapreciousmetals.com/apm-aff-lp-1-v3?apmtrkr_cid=1696&aff_id=5283&sub_id=YOUR_IDENTIFIER";

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Gold IRA Calculator', path: '/#gold-ira-calculator' },
    { name: 'Comparison Tool', path: '/portfolio-comparison' },
    { name: 'Gold IRA Review', path: '/gold-ira-review' },
    { name: 'Best Companies', path: '/best-gold-ira-companies' },
  ];

  return (
    <header className={`fixed w-full top-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-slate-900 shadow-2xl py-2' : 'bg-slate-900 py-4'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center">
          <Link to="/" className="flex items-center group relative">
            <div className="absolute inset-0 bg-white/20 blur-2xl rounded-full pointer-events-none -z-10 group-hover:bg-white/30 transition-colors duration-300"></div>
            <img src={LOGO_URL} alt="Secure Gold Investments" className="h-20 md:h-24 w-auto object-contain drop-shadow-[0_0_15px_rgba(255,255,255,0.7)] transition-transform duration-300 group-hover:scale-105" />
          </Link>

          <nav className="hidden lg:flex items-center gap-6 xl:gap-8">
            {navLinks.map((link) => (
              link.path.startsWith('/#') ? (
                <a key={link.name} href={link.path.substring(1)} className="text-slate-300 hover:text-white transition-colors font-bold text-sm xl:text-base">
                  {link.name}
                </a>
              ) : (
                <Link key={link.name} to={link.path} className={`transition-colors font-bold text-sm xl:text-base ${location.pathname === link.path ? 'text-yellow-400' : 'text-slate-300 hover:text-white'}`}>
                  {link.name}
                </Link>
              )
            ))}
            <a href={AFFILIATE_LINK} target="_blank" rel="noopener noreferrer" className="bg-yellow-400 text-slate-900 px-6 py-2.5 rounded-full hover:bg-yellow-300 transition-all font-black text-sm uppercase tracking-wide shadow-lg shadow-yellow-400/20">
              GET FREE Kit
            </a>
          </nav>

          <div className="lg:hidden">
            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="text-slate-300 hover:text-white p-2">
              <SafeIcon icon={mobileMenuOpen ? FiX : FiMenu} className="text-3xl" />
            </button>
          </div>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="lg:hidden bg-slate-900 border-t border-slate-800 absolute w-full animate-slideIn shadow-2xl">
          <div className="px-4 pt-4 pb-10 space-y-4">
            {navLinks.map((link) => (
              link.path.startsWith('/#') ? (
                <a key={link.name} href={link.path.substring(1)} onClick={() => setMobileMenuOpen(false)} className="block text-slate-300 hover:text-white font-bold text-lg py-3 border-b border-slate-800">
                  {link.name}
                </a>
              ) : (
                <Link key={link.name} to={link.path} onClick={() => setMobileMenuOpen(false)} className="block text-slate-300 hover:text-white font-bold text-lg py-3 border-b border-slate-800">
                  {link.name}
                </Link>
              )
            ))}
            <a href={AFFILIATE_LINK} target="_blank" rel="noopener noreferrer" className="block text-center text-slate-900 bg-yellow-400 px-4 py-4 rounded-xl font-black text-lg mt-6 shadow-xl">
              GET FREE INFO KIT
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;